export default __webpack_public_path__ + "static/media/logo-dark-bg.7b28c722.svg";